import { useEffect } from 'react'
import { Spin } from 'antd'
import { Router } from 'routing'
import { useAuth } from 'shared/hooks/useAuth'
import { showServerError } from 'shared/utils/showServerError'
import { MobileCabinetEntry } from 'pages/MobileCabinetEntry'
import { TOKEN } from 'shared/constants/app'

type NativeWindow = Window & {
  ReactNativeWebView?: { postMessage: (message: string) => void }
}

const AuthenticatedApp: React.FC = () => {
  const { isLoaded, isError } = useAuth()

  useEffect(() => {
    const bridge = new URLSearchParams(window.location.search).get('hs_bridge')
    if (!isLoaded || !bridge || window.location.pathname !== '/orders') return undefined
    const type = !isError && localStorage.getItem(TOKEN) ? 'authenticated' : 'error'
    const message = JSON.stringify({
      type, bridge, code: type === 'error' ? 'auth_failed' : undefined,
      retryable: type === 'error'
    })
    const send = () => (window as NativeWindow).ReactNativeWebView?.postMessage(message)
    send()
    // Дожидаемся подтверждения приложения: при первой отрисовке мост может
    // ещё не принимать сообщения после перехода между страницами.
    const timer = window.setInterval(send, 1000)
    const deadline = window.setTimeout(() => window.clearInterval(timer), 60000)
    const stop = (event: Event) => {
      if ((event as CustomEvent<{ bridge?: string }>).detail?.bridge === bridge) {
        window.clearInterval(timer)
        window.clearTimeout(deadline)
      }
    }
    window.addEventListener('hs-seller-cabinet-auth-ack', stop)
    return () => {
      window.clearInterval(timer)
      window.clearTimeout(deadline)
      window.removeEventListener('hs-seller-cabinet-auth-ack', stop)
    }
  }, [isLoaded, isError])

  if (!isLoaded) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Spin size='large' />
      </div>
    )
  }

  if (isError) {
    showServerError()
    return null
  }

  return <Router />
}

export const App: React.FC = () => (
  window.location.pathname === '/mobile-cabinet-entry'
    ? <MobileCabinetEntry />
    : <AuthenticatedApp />
)

export default App
